import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { useState } from 'react';

function DashboardHeader({ icon, title, subtitle, period, startDate, endDate }) {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    try {
      setIsDownloading(true);
      
      // Construir URL con parámetros
      const params = new URLSearchParams();
      if (period) {
        params.append('period', period);
      } else if (startDate && endDate) {
        params.append('start_date', startDate);
        params.append('end_date', endDate);
      }
      
      // Usar ruta relativa que pasa por el proxy de Vite
      const url = `/feedback/estadisticas/download/?${params.toString()}`;
      
      // Descargar archivo
      const response = await fetch(url);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response:', errorText);
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      
      // Extraer nombre del archivo del header o usar uno por defecto
      const contentDisposition = response.headers.get('Content-Disposition');
      const filename = contentDisposition 
        ? contentDisposition.split('filename=')[1].replace(/"/g, '')
        : `estadisticas_${new Date().toISOString().split('T')[0]}.xlsx`;
      
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);
      
    } catch (error) {
      console.error('Error completo al descargar:', error);
      alert(`Error al descargar las estadísticas: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div 
      className="bg-white rounded border shadow-sm p-4"
    >
      <div className="d-flex align-items-center">

        <div className="flex-grow-1">
          <p className="mb-1 h3">
            {title}
          </p>
          <p className="text-muted mb-0">
            {subtitle}
          </p>
        </div>
        <Button
          variant="success"
          onClick={handleDownload}
          disabled={isDownloading}
          className="d-flex align-items-center gap-2"
          style={{ whiteSpace: 'nowrap' }}
        >
          <i className="bi bi-file-earmark-spreadsheet"></i>
          {isDownloading ? 'Descargando...' : 'Descargar Excel'}
        </Button>
      </div>
    </div>
  );
}

DashboardHeader.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  period: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
};

DashboardHeader.defaultProps = {
  subtitle: '',
  period: null,
  startDate: null,
  endDate: null,
};

export default DashboardHeader;
